var z = (S) => {
  throw TypeError(S);
};
var O = (S, t, i) => t.has(S) || z("Cannot " + i);
var e = (S, t, i) => (O(S, t, "read from private field"), i ? i.call(S) : t.get(S)), I = (S, t, i) => t.has(S) ? z("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(S) : t.set(S, i), n = (S, t, i, u) => (O(S, t, "write to private field"), u ? u.call(S, i) : t.set(S, i), i), r = (S, t, i) => (O(S, t, "access private method"), i);
var M = (S, t, i, u) => ({
  set _(c) {
    n(S, t, c, i);
  },
  get _() {
    return e(S, t, u);
  }
});
var l, o, h, m, d, f, a, $, H, E, s, x, G, j, T, B, J, N, q, K, A, F, Z, D, R, L, P, U, V, W, k, Q, Y;
const p = class p {
  constructor(t) {
    I(this, s);
    I(this, l);
    I(this, o);
    I(this, h);
    I(this, m);
    I(this, d);
    I(this, f);
    I(this, a);
    I(this, $);
    I(this, H, [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]);
    I(this, E, [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]);
    if (!t) {
      const i = /* @__PURE__ */ new Date();
      n(this, l, i.getFullYear()), n(this, o, i.getMonth() + 1), n(this, h, i.getDate()), n(this, m, i.getHours()), n(this, d, i.getMinutes()), n(this, f, i.getSeconds()), n(this, a, i.getMilliseconds());
      return;
    }
    if (typeof t == "string") {
      if (/^[-+]?\d+-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}/.test(t)) {
        const { year: i, month: u, day: c, hour: w, minute: y, second: b, millisecond: g } = /^(?<year>[-+]?\d+)-(?<month>\d{2})-(?<day>\d{2})T(?<hour>\d{2}):(?<minute>\d{2}):(?<second>\d{2}).(?<millisecond>\d{3})/.exec(
          t
        ).groups;
        n(this, l, parseInt(i)), n(this, o, parseInt(u)), n(this, h, parseInt(c)), n(this, m, parseInt(w)), n(this, d, parseInt(y)), n(this, f, parseInt(b)), n(this, a, parseInt(g));
        return;
      }
      if (/^[-+]?\d+-\d{2}-\d{2}$/.test(t)) {
        const [i, u, c] = /^(-?\d{4})-(\d{2})-(\d{2})/.exec(t).slice(1);
        n(this, l, parseInt(i)), n(this, o, parseInt(u)), n(this, h, parseInt(c));
        return;
      }
      if (/^[-+]?\d+\/\d{2}\/-?\d{2}$/.test(t)) {
        const [i, u, c] = t.split("/");
        n(this, l, parseInt(i)), n(this, o, parseInt(u)), n(this, h, parseInt(c));
        return;
      }
      throw new Error(`Invalid date format, data received: ${t}`);
    }
    if (!("year" in t)) throw new Error("Year is required");
    n(this, l, t.year), n(this, o, t.month ?? null), n(this, h, t.day ?? null), n(this, m, t.hour ?? null), n(this, d, t.minute ?? null), n(this, f, t.second ?? null), n(this, a, t.millisecond ?? null), n(this, $, t.display_date ?? "");
  }
  get year() {
    return e(this, l);
  }
  get month() {
    return e(this, o);
  }
  get day() {
    return e(this, h);
  }
  get hour() {
    return e(this, m);
  }
  get minute() {
    return e(this, d);
  }
  get second() {
    return e(this, f);
  }
  get millisecond() {
    return e(this, a);
  }
  get displayDate() {
    return e(this, $);
  }
  /**
   * Creates a new `Day` instance from a UTC date string.
   *
   * @param {string} data - The UTC date string in the format "YYYY-MM-DDTHH:MM:SS.SSSZ".
   * @returns {Day} A new `Day` instance.
   * @throws {Error} If the date string is not provided or is in an invalid format.
   */
  static utc(t) {
    if (!t) throw new Error("Date is required");
    if (!/^([-+]?\d+)-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})/.test(t))
      throw new Error(`Invalid date format. Use "YYYY-MM-DDTHH:MM:SS.SSSZ", data received: ${t}`);
    const [i, u, c, w, y, b, g, X] = /^([-+]?\d+)-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})/.exec(t);
    return new p({
      year: parseInt(u),
      month: parseInt(c),
      day: parseInt(w),
      hour: parseInt(y),
      minute: parseInt(b),
      second: parseInt(g),
      millisecond: parseInt(X)
    });
  }
  /**
   * Sets the value of a specified attribute and returns a new `Day` instance.
   *
   * @param {SetValueType | 'displayDate'} type - The attribute to set. Possible values are:
   *   - 'year'
   *   - 'month'
   *   - 'day'
   *   - 'hour'
   *   - 'minute'
   *   - 'second'
   *   - 'millisecond'
   *   - 'displayDate'
   * @param {number | string} value - The value to set for the specified attribute. Must be a number for all attributes except 'displayDate', which must be a string.
   * @returns {Day} A new `Day` instance with the updated attribute.
   * @throws {Error} If the value is not a number for any attribute except 'displayDate', or if the attribute is invalid.
   */
  set(t, i) {
    if (t === "displayDate") {
      if (typeof i != "string") throw new Error("Display date must be a string");
      return new p({ ...r(this, s, Y).call(this), display_date: i });
    }
    if (typeof i != "number") throw new Error("Value must be a number");
    if (!["year", "month", "day", "hour", "minute", "second", "millisecond"].includes(t))
      throw new Error("Invalid property");
    return {
      year: () => new p({ ...r(this, s, Y).call(this), year: i }),
      month: () => new p({ ...r(this, s, Y).call(this), month: i }),
      day: () => new p({ ...r(this, s, Y).call(this), day: i }),
      hour: () => new p({ ...r(this, s, Y).call(this), hour: i }),
      minute: () => new p({ ...r(this, s, Y).call(this), minute: i }),
      second: () => new p({ ...r(this, s, Y).call(this), second: i }),
      millisecond: () => new p({ ...r(this, s, Y).call(this), millisecond: i })
    }[t]();
  }
  /**
   * Returns the date in the ISO 8601 format.
   *
   * @returns {string} The date in the ISO 8601 format.
   */
  toISOString() {
    var t, i, u, c, w, y;
    return `${e(this, l)}-${((t = e(this, o)) == null ? void 0 : t.toString().padStart(2, "0")) || "01"}-${((i = e(this, h)) == null ? void 0 : i.toString().padStart(2, "0")) || "01"}T${((u = e(this, m)) == null ? void 0 : u.toString().padStart(2, "0")) || "00"}:${((c = e(this, d)) == null ? void 0 : c.toString().padStart(2, "0")) || "00"}:${((w = e(this, f)) == null ? void 0 : w.toString().padStart(2, "0")) || "00"}.${((y = e(this, a)) == null ? void 0 : y.toString().padStart(3, "0")) || "000"}Z`;
  }
  /**
   * Adds a specified value to a given unit of time.
   *
   * @param {number} value - The value to add.
   * @param {SetValueType} unit - The unit of time to add the value to. Possible values are:
   *   - 'year'
   *   - 'month'
   *   - 'day'
   *   - 'hour'
   *   - 'minute'
   *   - 'second'
   *   - 'millisecond'
   * @returns {Day} The updated `Day` instance.
   */
  add(t, i) {
    return {
      year: () => n(this, l, e(this, l) + t),
      month: () => r(this, s, T).call(this, t),
      day: () => r(this, s, B).call(this, t),
      hour: () => r(this, s, J).call(this, t),
      minute: () => r(this, s, N).call(this, t),
      second: () => r(this, s, q).call(this, t),
      millisecond: () => r(this, s, K).call(this, t)
    }[i](), this;
  }
  /**
   * Subtracts a specified value from a given unit of time.
   *
   * @param {number} value - The value to subtract.
   * @param {SetValueType} unit - The unit of time to subtract the value from. Possible values are:
   *   - 'year'
   *   - 'month'
   *   - 'day'
   *   - 'hour'
   *   - 'minute'
   *   - 'second'
   *   - 'millisecond'
   * @returns {Day} The updated `Day` instance.
   */
  subtract(t, i) {
    return {
      year: () => n(this, l, e(this, l) - t),
      month: () => r(this, s, A).call(this, t),
      day: () => r(this, s, F).call(this, t),
      hour: () => r(this, s, Z).call(this, t),
      minute: () => r(this, s, D).call(this, t),
      second: () => r(this, s, R).call(this, t),
      millisecond: () => r(this, s, L).call(this, t)
    }[i](), this;
  }
  /**
   * Returns the difference between two dates in a specified unit of time.
   *
   * @param {Day} day - The date to compare to.
   * @param {SetValueType} unit - The unit of time to calculate the difference in. Possible values are:
   *   - 'year'
   *   - 'month'
   *   - 'day'
   *   - 'hour'
   *   - 'minute'
   *   - 'second'
   *   - 'millisecond'
   * @returns {number} The difference between the two dates in the specified unit of time.
   */
  diff(t, i) {
    const { here: u, there: c } = r(this, s, G).call(this, t);
    return {
      year: () => u.year - c.year,
      month: () => r(this, s, P).call(this, new p(u), new p(c)),
      day: () => r(this, s, U).call(this, new p(u), new p(c)),
      hour: () => r(this, s, V).call(this, new p(u), new p(c)),
      minute: () => r(this, s, W).call(this, new p(u), new p(c)),
      second: () => r(this, s, k).call(this, new p(u), new p(c)),
      millisecond: () => r(this, s, Q).call(this, new p(u), new p(c))
    }[i]();
  }
  /**
   * Checks if the current date is the same as the provided date.
   *
   * @param {Day} day - The date to compare to.
   * @param {SetValueType} [type] - The unit of time to compare. Possible values are:
   *   - 'year'
   *   - 'month'
   *   - 'day'
   *   - 'hour'
   *   - 'minute'
   *   - 'second'
   *   - 'millisecond'
   * @returns {boolean} `true` if the dates are the same, `false` otherwise.
   */
  isSame(t, i) {
    return this.toDecimal(i) === t.toDecimal(i);
  }
  /**
   * Checks if the current date is the same or before the provided date.
   *
   * @param {Day} day - The date to compare to.
   * @param {SetValueType} [type] - The unit of time to compare. Possible values are:
   *   - 'year'
   *   - 'month'
   *   - 'day'
   *   - 'hour'
   *   - 'minute'
   *   - 'second'
   *   - 'millisecond'
   * @returns {boolean} `true` if the current date is the same or before the provided date, `false` otherwise.
   */
  isSameBefore(t, i) {
    return this.toDecimal(i) <= t.toDecimal(i);
  }
  /**
   * Checks if the current date is before the provided date.
   *
   * @param {Day} day - The date to compare to.
   * @param {SetValueType} [type] - The unit of time to compare. Possible values are:
   *   - 'year'
   *   - 'month'
   *   - 'day'
   *   - 'hour'
   *   - 'minute'
   *   - 'second'
   *   - 'millisecond'
   * @returns {boolean} `true` if the current date is before the provided date, `false` otherwise.
   */
  isBefore(t, i) {
    return this.toDecimal(i) < t.toDecimal(i);
  }
  /**
   * Checks if the current date is the same or after the provided date.
   *
   * @param {Day} day - The date to compare to.
   * @param {SetValueType} [type] - The unit of time to compare. Possible values are:
   *   - 'year'
   *   - 'month'
   *   - 'day'
   *   - 'hour'
   *   - 'minute'
   *   - 'second'
   *   - 'millisecond'
   * @returns {boolean} `true` if the current date is the same or after the provided date, `false` otherwise.
   */
  isSameAfter(t, i) {
    return this.toDecimal(i) >= t.toDecimal(i);
  }
  /**
   * Checks if the current date is after the provided date.
   *
   * @param {Day} day - The date to compare to.
   * @param {SetValueType} [type] - The unit of time to compare. Possible values are:
   *   - 'year'
   *   - 'month'
   *   - 'day'
   *   - 'hour'
   *   - 'minute'
   *   - 'second'
   *   - 'millisecond'
   * @returns {boolean} `true` if the current date is after the provided date, `false` otherwise.
   */
  isAfter(t, i) {
    return this.toDecimal(i) > t.toDecimal(i);
  }
  /**
   * Formats the date using the provided format string.
   *
   * @param {string} format - The format string to use. The following tokens are available:
   *   - YYYY: The full year.
   *   - YY: The last two digits of the year.
   *   - MMMM: The full month name.
   *   - MMM: The abbreviated month name.
   *   - MM: The month as a two-digit number.
   *   - M: The month as a number.
   *   - DD: The day as a two-digit number.
   *   - D: The day as a number.
   *   - HH: The hour as a two-digit number.
   *   - H: The hour as a number.
   *   - mm: The minute as a two-digit number.
   *   - m: The minute as a number.
   *   - ss: The second as a two-digit number.
   *   - s: The second as a number.
   *   - SSS: The millisecond as a three-digit number.
   *   - S: The millisecond as a number.
   * @returns {string} The formatted date.
   */
  format(t) {
    if (e(this, o) === null && e(this, h) === null && e(this, m) === null && e(this, d) === null && e(this, f) === null && e(this, a) === null)
      return /YYYY/.test(t) ? e(this, l).toString() : e(this, l).toString().slice(-2);
    let i = t.replace(/YYYY/, e(this, l).toString()).replace(/YY/, e(this, l).toString().slice(-2)).replace(/DD/, e(this, h) ? e(this, h).toString().padStart(2, "0") : "01").replace(/D/, e(this, h) ? e(this, h).toString() : "1").replace(/HH/, e(this, m) ? e(this, m).toString().padStart(2, "0") : "00").replace(/H/, e(this, m) ? e(this, m).toString() : "0").replace(/mm/, e(this, d) ? e(this, d).toString().padStart(2, "0") : "00").replace(/m/, e(this, d) ? e(this, d).toString() : "0").replace(/ss/, e(this, f) ? e(this, f).toString().padStart(2, "0") : "00").replace(/s/, e(this, f) ? e(this, f).toString() : "0").replace(/SSS/, e(this, a) ? e(this, a).toString().padStart(3, "0") : "000").replace(/S/, e(this, a) ? e(this, a).toString() : "0");
    return /(MMM|MMMM)/.test(t) ? i = i.replace(/MMMM/, r(this, s, x).call(this, e(this, o), !1)).replace(/MMM/, r(this, s, x).call(this, e(this, o), !0)) : /(M|MM)/.test(t) && (i = i.replace(/MM/, e(this, o) ? e(this, o).toString().padStart(2, "0") : "01").replace(/M/, e(this, o) ? e(this, o).toString() : "1")), i;
  }
  /**
   * Converts the date to decimal. Very useful for efficiently comparing two dates.
   */
  toDecimal(t) {
    return {
      year: () => this.year * 1e10,
      month: () => this.toDecimal("year") + this.month * 1e8,
      day: () => this.toDecimal("month") + this.day * 1e6,
      hour: () => this.toDecimal("day") + this.hour * 1e4,
      minute: () => this.toDecimal("hour") + this.minute * 100,
      second: () => this.toDecimal("minute") + this.second,
      millisecond: () => this.toDecimal("second") + this.millisecond / 1e3
    }[t ?? "millisecond"]();
  }
};
l = new WeakMap(), o = new WeakMap(), h = new WeakMap(), m = new WeakMap(), d = new WeakMap(), f = new WeakMap(), a = new WeakMap(), $ = new WeakMap(), H = new WeakMap(), E = new WeakMap(), s = new WeakSet(), x = function(t, i) {
  return e(this, E)[t - 1].slice(0, i ? 3 : 9);
}, G = function(t) {
  return {
    here: {
      year: e(this, l),
      month: e(this, o) ?? 1,
      day: e(this, h) ?? 1,
      hour: e(this, m) ?? 0,
      minute: e(this, d) ?? 0,
      second: e(this, f) ?? 0,
      millisecond: e(this, a) ?? 0
    },
    there: {
      year: t.year,
      month: t.month ?? 1,
      day: t.day ?? 1,
      hour: t.hour ?? 0,
      minute: t.minute ?? 0,
      second: t.second ?? 0,
      millisecond: t.millisecond ?? 0
    }
  };
}, j = function() {
  e(this, h) && e(this, h) > e(this, H)[e(this, o) - 1] && n(this, h, e(this, o) === 2 ? e(this, l) % 4 === 0 && e(this, l) % 100 !== 0 || e(this, l) % 400 === 0 ? 29 : 28 : e(this, H)[e(this, o) - 1]);
}, T = function(t) {
  e(this, o) || n(this, o, 1);
  for (let i = 0; i < t; i++) {
    if (e(this, o) === 12) {
      M(this, l)._++, n(this, o, 1);
      continue;
    }
    M(this, o)._++;
  }
  r(this, s, j).call(this);
}, B = function(t) {
  e(this, h) || n(this, h, 1);
  for (let i = 0; i < t; i++) {
    if (e(this, o) === 2) {
      if (e(this, l) % 4 === 0 && e(this, l) % 100 !== 0 || e(this, l) % 400 === 0) {
        if (e(this, h) === 29) {
          n(this, h, 1), r(this, s, T).call(this, 1);
          continue;
        }
        M(this, h)._++;
        continue;
      }
      if (e(this, h) === 28) {
        n(this, h, 1), r(this, s, T).call(this, 1);
        continue;
      }
      M(this, h)._++;
      continue;
    }
    e(this, h) === e(this, H)[e(this, o) - 1] ? (n(this, h, 1), r(this, s, T).call(this, 1)) : M(this, h)._++;
  }
}, J = function(t) {
  e(this, m) === null && n(this, m, 0);
  for (let i = 0; i < t; i++) {
    if (e(this, m) === 23) {
      n(this, m, 0), r(this, s, B).call(this, 1);
      continue;
    }
    M(this, m)._++;
  }
}, N = function(t) {
  e(this, d) === null && n(this, d, 0);
  for (let i = 0; i < t; i++) {
    if (e(this, d) === 59) {
      n(this, d, 0), r(this, s, J).call(this, 1);
      continue;
    }
    M(this, d)._++;
  }
}, q = function(t) {
  e(this, f) === null && n(this, f, 0);
  for (let i = 0; i < t; i++) {
    if (e(this, f) === 59) {
      n(this, f, 0), r(this, s, N).call(this, 1);
      continue;
    }
    M(this, f)._++;
  }
}, K = function(t) {
  e(this, a) === null && n(this, a, 0);
  for (let i = 0; i < t; i++) {
    if (e(this, a) === 999) {
      n(this, a, 0), r(this, s, q).call(this, 1);
      continue;
    }
    M(this, a)._++;
  }
}, A = function(t) {
  e(this, o) || n(this, o, 1);
  for (let i = 0; i < t; i++) {
    if (e(this, o) === 1) {
      M(this, l)._--, n(this, o, 12);
      continue;
    }
    M(this, o)._--;
  }
  r(this, s, j).call(this);
}, F = function(t) {
  e(this, h) || n(this, h, 1);
  for (let i = 0; i < t; i++) {
    if (e(this, o) === 3 && e(this, h) === 1) {
      n(this, h, e(this, l) % 4 === 0 && e(this, l) % 100 !== 0 || e(this, l) % 400 === 0 ? 29 : 28), r(this, s, A).call(this, 1);
      continue;
    }
    if (e(this, h) === 1) {
      n(this, h, e(this, H)[e(this, o) === 1 ? 11 : e(this, o) - 2]), r(this, s, A).call(this, 1);
      continue;
    }
    M(this, h)._--;
  }
}, Z = function(t) {
  e(this, m) === null && n(this, m, 0);
  for (let i = 0; i < t; i++) {
    if (e(this, m) === 0) {
      n(this, m, 23), r(this, s, F).call(this, 1);
      continue;
    }
    M(this, m)._--;
  }
}, D = function(t) {
  e(this, d) === null && n(this, d, 0);
  for (let i = 0; i < t; i++) {
    if (e(this, d) === 0) {
      n(this, d, 59), r(this, s, Z).call(this, 1);
      continue;
    }
    M(this, d)._--;
  }
}, R = function(t) {
  e(this, f) === null && n(this, f, 0);
  for (let i = 0; i < t; i++) {
    if (e(this, f) === 0) {
      n(this, f, 59), r(this, s, D).call(this, 1);
      continue;
    }
    M(this, f)._--;
  }
}, L = function(t) {
  e(this, a) === null && n(this, a, 0);
  for (let i = 0; i < t; i++) {
    if (e(this, a) === 0) {
      n(this, a, 999), r(this, s, R).call(this, 1);
      continue;
    }
    M(this, a)._--;
  }
}, P = function(t, i) {
  return t.year === i.year ? t.month - i.month : t.isAfter(i) ? 12 - i.month + t.month + 12 * (Math.abs(t.year - i.year) - 1) : (12 - t.month + i.month + 12 * (Math.abs(t.year - i.year) - 1)) * -1;
}, U = function(t, i) {
  if (t.year === i.year && t.month === i.month) return t.day - i.day;
  const u = t.isBefore(i), c = u ? t : i, w = u ? i : t, y = c.year === w.year;
  let b = 0;
  for (let g = c.month ?? 1; y ? g < (w.month ?? 1) : g <= 12; g++)
    b += g === 2 ? c.year % 4 === 0 && c.year % 100 !== 0 || c.year % 400 === 0 ? 29 : 28 : e(this, H)[g - 1];
  if (!y) {
    for (let g = 1; g < (w.month ?? 1); g++)
      b += g === 2 ? w.year % 4 === 0 && w.year % 100 !== 0 || w.year % 400 === 0 ? 29 : 28 : e(this, H)[g - 1];
    for (let g = c.year + 1; g < w.year; g++)
      b += g % 4 === 0 && g % 100 !== 0 || g % 400 === 0 ? 366 : 365;
  }
  return b -= c.day ?? 1, b += w.day ?? 1, b * (u ? -1 : 1);
}, V = function(t, i) {
  return t.year === i.year && t.month === i.month && t.day === i.day ? t.hour - i.hour : r(this, s, U).call(this, t, i) * 24 + (t.hour - i.hour);
}, W = function(t, i) {
  return t.year === i.year && t.month === i.month && t.day === i.day && t.hour === i.hour ? t.minute - i.minute : r(this, s, V).call(this, t, i) * 60 + (t.minute - i.minute);
}, k = function(t, i) {
  return t.year === i.year && t.month === i.month && t.day === i.day && t.hour === i.hour && t.minute === i.minute ? t.second - i.second : r(this, s, W).call(this, t, i) * 60 + (t.second - i.second);
}, Q = function(t, i) {
  return t.year === i.year && t.month === i.month && t.day === i.day && t.hour === i.hour && t.minute === i.minute && t.second === i.second ? t.millisecond - i.millisecond : r(this, s, k).call(this, t, i) * 1e3 + (t.millisecond - i.millisecond);
}, Y = function() {
  const t = { year: e(this, l) };
  return e(this, o) !== null && (t.month = e(this, o)), e(this, h) !== null && (t.day = e(this, h)), e(this, m) !== null && (t.hour = e(this, m)), e(this, d) !== null && (t.minute = e(this, d)), e(this, f) !== null && (t.second = e(this, f)), e(this, a) !== null && (t.millisecond = e(this, a)), e(this, $) !== null && (t.display_date = e(this, $)), t;
};
let C = p;
export {
  C as Day
};
//# sourceMappingURL=limitdayjs.js.map
